import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";

import { Box } from "@mui/material";
import { CountryService } from "../../../services/common/CountryService";

interface ICityInfoSetupFieldsPanel {
	countryList: {
		shortCode?: string;
		label: string;
		value: string;
		countryType: string;
	}[];
	provinceDDLLoading: (value: boolean) => void;
	formMethods: any;
	provinceStateDDLinUpdate?: any;
	provinceDDLItems: any;
	provinceStateLabelinUpdate?: any;
	onProvinceSelectionChangeHandler: (value: any) => void;
}
export const CityInfoSetupFieldsPanel: FC<ICityInfoSetupFieldsPanel> = ({
	countryList,
	provinceDDLLoading,
	formMethods,
	provinceStateDDLinUpdate,
	provinceDDLItems,
	provinceStateLabelinUpdate,
	onProvinceSelectionChangeHandler
}) => {
	const navigateToLogout = useNavigateToLogout();

	const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
	const [countrytype, setCountrytype] = useState("Province");
	const [selectedCountryShortCode, setSelectedCountryShortCode] =
		useState<any>("");
	const [selectedCountry, setSelectedCountry] = useState<any>("");

	// const onCountryChangeHandler = async (e: any) => {

	// 		setSelectedCountryShortCode(e.shortCode);
	// 		setSelectedCountry(e.value)
	// 		let selected = e.value;
	// 		setCountrytype(
	// 			e.countryType === "province"
	// 				? "Province"
	// 				: e.countryType === "state"
	// 				? "State"
	// 				: e.countryType
	// 		);
	// 		formMethods.setValue("province", undefined);
	// 		formMethods.setValue("state", undefined);
	// 		try {
	// 			provinceDDLLoading(true);
	// 			const responce = await CountryService.getProvinceOrStateDDL(
	// 				navigateToLogout,
	// 				selected,
	// 				e.countryType
	// 			);
	// 			setprovinceOrStateDDL(responce);
	// 			provinceDDLItems(responce);
	// 		} catch {

	// 		} finally {
	// 			provinceDDLLoading(false);
	// 		}
	// 	};

	useEffect(() => {
		// if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {

		// 	setprovinceOrStateDDL(provinceStateDDLinUpdate);
		// 	provinceDDLItems(provinceStateDDLinUpdate);
		// 	setCountrytype(
		// 		provinceStateLabelinUpdate === "province"
		// 			? "Province"
		// 			: provinceStateLabelinUpdate === "state"
		// 			? "State"
		// 			: provinceStateLabelinUpdate
		// 	);
		// }
		if (countryList) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				setSelectedCountryShortCode(canada.shortCode);
				setSelectedCountry(canada.value);
				(async () => {
					try {
						provinceDDLLoading(true);
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setprovinceOrStateDDL(response);
						provinceDDLItems(response);
					} catch (err) {
						console.error("error", err);
					} finally {
						provinceDDLLoading(false);
					}
				})();
			}
		}
	}, [provinceStateLabelinUpdate, provinceStateDDLinUpdate, countryList]);
	return (
		<Box
			sx={{
				padding: "0",
			}}
		>
			{provinceOrStateDDL && (
				<EnhancedDropDownRHFWithLabel
					selectName={"provinceState"}
					label={countrytype}
					labelPosition={LabelPosition.Top}
					// required
					testId={`province-list`}
					items={sortDDLByLabel(provinceOrStateDDL) ?? []}
					labelColumns={4}
					fieldColumns={8}
					onSelectionChangeHandler={onProvinceSelectionChangeHandler}
				/>
			)}
			<RHookFormTextFieldWithLabel
				label="City Name"
				id="name"
				testId={`name`}
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
